import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import Scrollbars from "react-custom-scrollbars";
import { Fragment } from 'react';
import Chip from './chip';
import InformationIcon from '../atoms/information-icon';
import DropdownMenu from './dropdown_menu';
import { questionHintTypes } from '../constants';
import { SECONDARY_COLOR } from '../color-constants';

const QuestionWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

const QuestionLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const QuestionLabel = styled.h5`
  margin: 0;
  color: #333333;
  font-size: 12px !important;
  line-height: normal !important;
  font-weight: bold;
`;

const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;


const HintIcon = styled.span`
  display: inline-block;
  margin-left: 4px;
  color: #6D6F75;
  cursor: pointer;
`;

const QuestionDetailModal = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(51,51,51, 0.5);
  justify-content: center;
  align-items: flex-end;
  z-index: 410;
`;

const QuestionDetailContainer = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
`;

const QuestionDetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  border-bottom: 2px solid ${SECONDARY_COLOR};
  border-bottom: 2px solid var(--se-primary, ${SECONDARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const QuestionDetailModalTitle = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  cursor: pointer;
`;

const QuestionDetailContent = styled.div`
  display: flex;
  flex: 1;
  padding: 10px 20px;
`;

const QuestionDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0px;
`;

const QuestionDetailDescription = styled.span``;

const QuestionDetailTitle = styled.span`
  font-weight: bold;
  margin-bottom: 10px;
`;

const QuestionLabelWithOptional = styled.div`
  display: flex;
  align-items: center;
`;

const OptionalLabel = styled.div`
  font-size: 10px;
  color: #BFBFBF;
  margin-left: 5px;
`;

const HintDropdownWrapper = styled.div`
  width: 200px;
  position: relative;
  padding: 15px;
  font-size: 14px;
  white-space: pre-wrap;
`;

class Question extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      questionDetailOpen: false,
    }
  }


  static propTypes = {
    question: PropTypes.object,
    onAnswerChanged: PropTypes.func,
    answerGiven: PropTypes.array,
    remainingOptions: PropTypes.object,
    sharedOptions: PropTypes.object,
    baseOptions: PropTypes.object,
    resultsLoading: PropTypes.bool,
    forceActiveOptions: PropTypes.bool,
    scrollbarWrapper: PropTypes.object,
    showOptional: PropTypes.bool,
    questionHintType: PropTypes.number
  }

  updateState = (question, value) => {
    if (this.props.answerGiven && this.props.answerGiven.includes(value)) {
      this.props.onAnswerChanged(question, value, 'remove');
    } else {
      this.props.onAnswerChanged(question, value, 'add');
    }
  }

  isInSharedOptions = (criteriaValue) => {
    let result = false;
    if (
      (!this.props.answerGiven || (this.props.answerGiven && !this.props.answerGiven.includes(criteriaValue)))
      && this.props.sharedOptions
      && this.props.sharedOptions[this.props.question.criteria]
      && this.props.sharedOptions[this.props.question.criteria].includes(criteriaValue)) {

      result = true;
    }
    return result;
  }


  renderAnswerOptions = () => {
    return this.props.question.options
      .map((option) => {
        let shouldBeDisabled = this.props.resultsLoading;
        let shouldBeShown = true;
        let isInSharedOptions = this.isInSharedOptions(option.criteriaValue);

        // Check if base options was provided and if criteria is present in base options.
        if (this.props.baseOptions && this.props.baseOptions[this.props.question.criteria]) {
          const baseOptionsForQuestion = this.props.baseOptions[this.props.question.criteria];
          // If the current option is not in the base options, do not show it.
          if (!baseOptionsForQuestion.includes(option.criteriaValue)) {
            shouldBeShown = false;
          }
        }

        // Check if remaining options was provided and if criteria is present in remaining options.
        if (this.props.remainingOptions && this.props.remainingOptions[this.props.question.criteria]) {
          const availableOptionsForQuestion = this.props.remainingOptions[this.props.question.criteria];
          // If the current option is not in the remaining options, disable it.
          if (!availableOptionsForQuestion.includes(option.criteriaValue) && !this.props.forceActiveOptions) {
            shouldBeDisabled = true;
          }
        }

        return (
          <Fragment key={option.answerKey}>
            {shouldBeShown && <Chip
              id={`${option.answerKey}-answer`}
              scrollbarWrapper={this.props.scrollbarWrapper}
              loading={this.props.resultsLoading}
              disabled={shouldBeDisabled || this.props.resultsLoading}
              title={option.detailedAnswer ? I10n.getOrDefault(`answers.${option.answerKey}.detailed`, option.detailedAnswer, 'data') : ''}
              value={I10n.getOrDefault(`answers.${option.answerKey}.label`, option.answer, 'data')}
              selected={(this.props.answerGiven && this.props.answerGiven.includes(option.criteriaValue)) && !isInSharedOptions}
              preSelected={isInSharedOptions}
              showCheck={true}
              showHint={true}
              onClick={() => {
                if (!shouldBeDisabled && !isInSharedOptions) {
                  this.updateState(this.props.question, option.criteriaValue);
                }
              }}>
            </Chip>}
          </Fragment>
        );
      });
  }

  shouldRenderQuestionDetail = (question) => {
    return question.detailedQuestion !== undefined || question.options.filter((opt) => opt.detailedAnswer !== undefined).length > 0;
  }

  renderQuestionDetail = (question) => {
    return (<QuestionDetailModal>
      <QuestionDetailContainer>
        <QuestionDetailHeader>
          <QuestionDetailModalTitle>{I10n.getOrDefault(`questions.${question.questionKey}.label`, question.question, 'data')}</QuestionDetailModalTitle>
          <CloseIcon onClick={(e) => {
            e.preventDefault();
            this.setState({ questionDetailOpen: false })
          }}>
            <MsxIcons name="modal-close"></MsxIcons>
          </CloseIcon>
        </QuestionDetailHeader>
        <QuestionDetailContent>
          <Scrollbars>
            {question.detailedQuestion && I10n.getOrDefault(`questions.${question.questionKey}.detailed`, question.detailedQuestion, 'data')}
            {question.options
              .filter(option => { return (this.props.baseOptions == null || this.props.baseOptions[question.criteria].includes(option.criteriaValue)); })
              .map((option, key) => {
                return (option.detailedAnswer && <QuestionDetailWrapper key={key}>
                  <QuestionDetailTitle>{I10n.getOrDefault(`answers.${option.answerKey}.label`, option.answer, 'data')}</QuestionDetailTitle>
                  <QuestionDetailDescription>{I10n.getOrDefault(`answers.${option.answerKey}.detailed`, option.detailedAnswer, 'data')}</QuestionDetailDescription>
                </QuestionDetailWrapper>)
              })
            }
          </Scrollbars>
        </QuestionDetailContent>
      </QuestionDetailContainer>
    </QuestionDetailModal>);
  }

  render = () => {
    const shouldRenderQuestionDetail = this.shouldRenderQuestionDetail(this.props.question);
    return (
      <QuestionWrapper>
        <QuestionLabelWrapper>
          <QuestionLabelWithOptional>
            <QuestionLabel title={
              this.props.question.detailedQuestion ?
                I10n.getOrDefault(`questions.${this.props.question.questionKey}.detailed`, this.props.question.detailedQuestion, 'data') :
                I10n.getOrDefault(`questions.${this.props.question.questionKey}.label`, this.props.question.question, 'data')
            }>
              {I10n.getOrDefault(`questions.${this.props.question.questionKey}.label`, this.props.question.question, 'data')}

            </QuestionLabel>
            {this.props.showOptional && !this.props.question.isMandatory && <OptionalLabel>{I10n.get('screen.question.optional')}</OptionalLabel>}
          </QuestionLabelWithOptional>
          {shouldRenderQuestionDetail && (this.props.questionHintType === questionHintTypes.dropdown ? <DropdownMenu
            data-clickable
            toggleElement={<HintIcon>
              <InformationIcon size="small"></InformationIcon>
            </HintIcon>}
            containerElement={
              <HintDropdownWrapper>{I10n.getOrDefault(`questions.${this.props.question.questionKey}.detailed`, this.props.question.detailedQuestion, 'data')}</HintDropdownWrapper>
            }
            allowTop={true}
            boundingElement={this.props.scrollbarWrapper}
          ></DropdownMenu> : <HintIcon onClick={() => { this.setState({ questionDetailOpen: true }) }}>
            <InformationIcon size="small"></InformationIcon>
          </HintIcon>)}
        </QuestionLabelWrapper>
        <AnswersWrapper>
          {this.renderAnswerOptions()}
        </AnswersWrapper>
        {this.state.questionDetailOpen && this.props.questionHintType !== questionHintTypes.dropdown && shouldRenderQuestionDetail && this.renderQuestionDetail(this.props.question)}
      </QuestionWrapper>
    );
  }
}

export default Question;
